import type { MeasurementSeries } from '../../lib/dashboard/measurementSeries';
import { MeasurementCard } from './measurement-card';
import {
  formatChange,
  formatMetricNumber,
  roundMetric,
  shortDate,
} from '../lib/metric-format';

/**
 * Every tracked circumference, one card each, with its history behind it.
 *
 * `import type` only — the boundary test allows a type from lib/ precisely
 * because the compiler erases it, so no app runtime follows it into the
 * design-system bundle.
 */
export const MeasurementGrid: React.FC<{
  series: MeasurementSeries[];
  targetBodyFat?: number;
  /** Band label for the body-fat reading, e.g. "Healthy". */
  bodyFatCategory?: string;
  className?: string;
}> = ({ series, targetBodyFat, bodyFatCategory, className = '' }) => (
  <div
    data-testid="measurement-grid"
    className={`grid grid-cols-1 gap-3.5 sm:grid-cols-2 xl:grid-cols-3 ${className}`}
  >
    {series.map((s) => (
      <MeasurementCard
        key={s.key}
        testId={`measurement-${s.key}`}
        myTarget={s.key === 'body_fat' ? targetBodyFat : undefined}
        category={s.key === 'body_fat' ? bodyFatCategory : undefined}
        title={s.title}
        values={s.values.map((v) => ({
          id: v.id,
          value: roundMetric(s.key, v.value),
          date: v.date,
        }))}
        // Formatted by the same rule as the hero, the change strip and the
        // Target page — this card rounded body fat to a whole number, so
        // 23.7 % there read 24 % here.
        value={formatMetricNumber(s.key, s.latest)}
        unit={s.unit}
        change={s.values.length > 1 && s.change !== 0 ? formatChange(s.key, s.change) : undefined}
        asOf={s.asOf ? shortDate(s.asOf) : undefined}
      />
    ))}
  </div>
);
